import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { Helmet } from 'react-helmet';

import { Book, useBook } from 'api/book/model';
import { Box, CustomBox, GridChild, GridContainer } from 'common';
import { useEffect, useState } from 'react';
import { BookCard } from 'widgets/cards';

import { useLanguage } from '../../context/LanguageContext';
import { bookClubPageLabels } from '../../locales/translations'

export const BooksPage = () => {
    const [bookList, setBookList] = useState<Book[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { onGetAllBooks } = useBook();

    const { language } = useLanguage();
    const title = bookClubPageLabels.title[language];
    const pageTitle = bookClubPageLabels.pageTitle[language];
    const metaDescription = bookClubPageLabels.metaDescription[language];

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllBooks();
                if (result.success) {
                    const sortedBook = result.data
                        .filter((a: Book) => a.show)
                        .sort((a: Book, b: Book) => 
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setBookList(sortedBook);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllBooks]);

    return (
        <CustomBox title={title}>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <Alert severity="error">{error}</Alert>
            ) : (
                <Box>
                    <GridContainer>
                        {bookList.map((bookItem) => (
                            <GridChild md={3} key={bookItem.id}>
                                <BookCard bookItem={bookItem} />
                            </GridChild>
                        ))}
                    </GridContainer>
                </Box>
            )}
        </CustomBox>
    );
};
